<template>
  <section class="banner_section_1">
    <ul class="banner_box">
      <li class="banner_item" bg-url="@/plan/assets/image/1/banner.jpg" v-bg></li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Banner',
  data() {
    return {
      timre: null,
      curImg: 1
    }
  },
  methods: {
    // 暂时不需要轮播

    // stopBanner() {
    //   this.timer && clearTimeout(this.timer)
    // },

    // runBanner() {
    //   this.stopBanner()

    //   this.timer = setTimeout(() => {
    //     this.$gsap.to(`.banner${this.curImg}`, { opacity: 0, duration: 1 })
        
    //     this.curImg = this.curImg % 2 + 1
    //     this.$gsap.to(`.banner${this.curImg}`, { opacity: 1, duration: 0.5 })
        
    //     this.runBanner()
    //   }, 3000)
    // },

    // runTimeline() {
    //   const tl = this.$gsap.timeline({
    //     scrollTrigger:{
    //       target: '.banner_section_1',
    //       markers: true,
    //     }
    //   })
    // },

    onLaunch() {
      // this.runBanner()
    }
  }
}
</script>


<style lang="less" scoped>
.banner_section_1 {
  position: relative;
  width: 100%;
  height: 680px;
  overflow: hidden;
}

.banner_box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;

  li {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: 2560px auto;
  }
}
</style>
